import { DailyTrendsChart } from "@/components/Dashboard/TimeAnalytics/DailyTrendsChart";
import { useGetTimeAnalyticsQuery } from "@/redux/services/dashboard/dashboard.api";

interface ReportChartsSectionProps {
  restaurantId: string;
  startDate: string;
  endDate: string;
}

/**
 * The period's revenue/orders trend (full width). Period-over-period comparison
 * is on by default to match the rest of the page. Shares the time-analytics
 * query with the KPI sparklines and peak-times section, so RTK Query serves it
 * from cache (SFRESTO-87).
 */
function ReportChartsSection({
  restaurantId,
  startDate,
  endDate,
}: ReportChartsSectionProps) {
  const { data: timeData, isFetching: timeLoading } = useGetTimeAnalyticsQuery(
    {
      restaurant_id: restaurantId,
      start_date: startDate,
      end_date: endDate,
      compare: true,
    },
    { skip: !restaurantId },
  );

  return (
    <DailyTrendsChart
      data={timeData?.data.current.daily_trends ?? []}
      previousData={timeData?.data.previous?.daily_trends}
      loading={timeLoading}
      height={440}
    />
  );
}

export default ReportChartsSection;
